(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
  });

  initProductAccordion();
  initZoomImage();

  // 材质弹窗
  $('#materialsLink').on('click', () => {
    Swal.fire({
      // title: "<strong>HTML <u>example</u></strong>",
      html: $('#materialsPopup').html(),
      showCloseButton: true,
    });
  })


  // 吸顶加购按钮
  // const productDescription = document.querySelector('.product__description');
  const addToCartSection = document.querySelector('.add-to-cart-section');
  const stickyElement = document.querySelector('.add-to-cart-section .product-form');

  var io = new IntersectionObserver(function(entries){
    if(entries[0].intersectionRatio){
      stickyElement.classList.remove('sticky');
    }else{		
      stickyElement.classList.add('sticky');
    }
  }); 
  
  io.observe(addToCartSection);
  

})();
